import TestWorkflowModel from "@/models/lab/TestWorkflowModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class TestWorkflowCollection extends LabServiceCollection {
  model() {
    return TestWorkflowModel;
  }

  prepareFilter(CollectionFilter) {

    return CollectionFilter;
  }
}
